// Usuario de la sesión ya abierta, leído de la sesión local (sin viaje de red).
// 2-nov (react-best-practices, async-parallel): los servicios pedían
// supabase.auth.getUser() en cada lectura, un viaje a /auth/v1/user antes de la
// consulta real (27 llamadas en 18 servicios). Para tomar el id o el correo
// basta la sesión: la base valida el JWT en CADA consulta con RLS, así que no
// se gana seguridad yendo a la red. Para verificar contra el servidor (p. ej.
// tras cambiar la contraseña) se sigue usando supabase.auth.getUser().
// Misma forma de respuesta que getUser(): { data: { user } }.
import type { User } from '@supabase/supabase-js';
import { supabase } from '@/lib/supabase';

export async function sessionUser(): Promise<{ data: { user: User | null } }> {
  const { data } = await supabase.auth.getSession();
  return { data: { user: data.session?.user ?? null } };
}
